export const noteStyles = {
  padding: '12px',
  display: 'flex',
  justifyContent: 'space-between',
  columnGap: '20px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '8px',
};

export const typographyStyles = {
  wordBreak: 'break-word',
  whiteSpace: 'pre-line',
};

export const controlsStyles = {
  marginTop: '20px',
  width: '100%',
  display: 'flex',
  gap: '4px',
  justifyContent: 'flex-end',
};
